import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-container">
      <header className="about-header">
        <h1>About Us</h1>
        <p>
          Providing compassionate and dignified pet cremation and burial
          services to honor your beloved companions.
        </p>
      </header>
      <div className="honor-pet-section">
  <div className="honor-pet-container">
    
    {/* Left - Content */}
    <div className="honor-pet-content">
      <h2 className="honor-pet-title">Pet Cremation and <span>Burial Services</span></h2>
      <p className="about-content-para1"> 
        Providing compassionate and dignified pet cremation and burial services to honor your beloved companions. 
        We understand that pets are more than just animals; they are family, confidants, and the purest source of love.
      </p>
      <p className="about-content-para">
        The loss of a pet leaves an irreplaceable void, but their love and memories live forever in our hearts. 
        Whether it’s a joyful bark, a gentle purr, or a comforting presence, their essence remains with us, shaping our lives in ways words cannot describe.
      </p>
    </div>

    {/* Right - Image */}
    <div className="honor-pet-image">
      <img src='images/resort-service-people2-20240308-173832.png' alt="Pet Memorial" />
    </div>
  </div>
</div>
      <section className="about-content">
        <div className="about-card">
          <img src="images/image-54474-800.jpg" alt="Pet Memorial" />
          <h3>Personalized Pet Services</h3>
          <p>We offer tailored cremation and burial services with care and respect.</p>
        </div>
        <div className="about-card">
          <img src="images/istockphoto-1248452712-612x612.jpg" alt="Pet Remembrance" />
          <h3>Memorial Options</h3>
          <p>Choose from various memorials to cherish your pet’s memory forever.</p>
        </div>
        <div className="about-card">
          <img src="images/helena-lopes-YgGZkMWe-Fc-unsplash-scaled.jpg" alt="Saying Goodbye" />
          <h3>A Place for Goodbye</h3>
          <p>We provide a peaceful setting to say your final goodbye with love and dignity.</p>
        </div>
      </section>
      <footer className="about-footer">
        <p>🐾 Honoring their love, cherishing their memory. 🐾</p>
      </footer>
    </div>
  );
};

export default About;
